import { init, trackTp } from '@changba/funny'
import { getGlobalParams } from "@changba/funny";
import ChangbaComponent from "@changba/component";
import "@changba/component/lib/style.css";
import ChangbaDialogPlugin from "@changba/dialog-plugin";
import { Toast, CountDown } from "vant";
import Vue from "vue";
import store from "./store/store.js";
import router from "./router/router.js";
// 需要图片延迟加载请取消注释
// import 'lazysizes';

trackTp();

import App from "./App.vue";
import "./components";
import "./index.scss";

Vue.use(ChangbaComponent);
Vue.use(Toast);
Vue.use(CountDown);
Vue.use(ChangbaDialogPlugin);

Vue.config.productionTip = false;

(async function bootstrap() {
  const params = await getGlobalParams();
  const { userId } = params;
  localStorage.setItem("userid", userId);
  init();
  window.app = new Vue({
    store,
    router,
    render: (h) => h(App),
  }).$mount("#app");
})();

window.beforePageDestroy = () => {
  const audioList = [...document.querySelectorAll("audio")];
  audioList.forEach((audio) => {
    if (!audio.paused) {
      audio.pause();
    }
  });
  const videoList = [...document.querySelectorAll("video")];
  videoList.forEach((video) => {
    if (!video.paused) {
      video.pause();
    }
  });
};
